import $ from 'jquery';
import isElement from './util/isElement';

const selectors = {
	anchor: '.js--anchor'
};

const SPEED_SCROLL = 0;
const HEADER_HEIGHT = 79;

const anchorscrollTo = (href, speed) => {
	const toScroll = $('[name="' + decodeURIComponent(href) + '"]');
	const anchorIndent = HEADER_HEIGHT;

	$('html').stop().animate({scrollTop: toScroll.offset().top - anchorIndent}, speed);
};

const anchorscrollCheckOnLoad = speed => {
	if (window.location.hash) {
		setTimeout(function () {
			anchorscrollTo(window.location.hash.replace('#', ''), speed);
		}, 0);
	}
};

const render = () => {
	$(window).on('load', function () {
		if (isElement(selectors.anchor)) {
			anchorscrollCheckOnLoad(SPEED_SCROLL);
		}
	});
};

export default render;
